import CreatableSelect from 'react-select/creatable';
import styled from 'styled-components';

/** Uppercase section divider used inside sidebar alert/schedule forms */
export const AlertSectionTitle = styled.div`
  color: rgba(255, 255, 255, 0.85);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-bottom: 12px;
  margin-top: ${props => props.marginTop || '8px'};
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
`;

/** Info card shown when a summary (daily/weekly/monthly) frequency is selected */
export const AlertSummaryInfoCard = styled.div`
  margin-bottom: 16px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  line-height: 1.5;
`;

/** Relative-positioned wrapper for the subject textarea + character counter */
export const AlertSubjectWrapper = styled.div`
  position: relative;
`;

/** Absolute character counter overlaid on the subject textarea */
export const AlertCharCounter = styled.small`
  position: absolute;
  bottom: 6px;
  right: 10px;
  font-size: 11px;
  pointer-events: none;
`;

export const UpperButton = styled.div`
    button {
        font-size: 10px;
        padding: 6px 12px;
        margin-bottom: 6px;
        background: #414042;
        border-radius: 8px;
        border: none;
        text-align: center;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #FFFFFF;
    }
`;

export const SelectExternalUserEmail = styled(CreatableSelect)`
    div.select-external-user-email__control {
        background-color: #e5e5e5;
        border-radius: 20px;
    }
`;

